module.exports = __webpack_public_path__ + "img/Rectangulo527.9a709fea.png";